// Carte Deseos.
// Les prix (p) ne changent pas. Les noms de plats (n) sont écrits en espagnol
// et traduits via NAMES ci-dessous (nom espagnol -> { fr, ar, ru }).
// Tout le reste (catégories, descriptions, listes de parfums) est traduit :
// une valeur traduisible s'écrit { es, fr, ar, ru }.

export const tr = (v, lang) => {
  if (v == null) return v;
  if (typeof v === "string") return v;
  return v[lang] || v.es;
};

// Traduction des noms de plats. Un nom absent reste en espagnol.
const NAMES = {
  "Aceite de oliva": { fr: "Huile d'olive", ar: "زيت الزيتون", ru: "Оливковое масло" },
  "Clásica de Tomate": { fr: "Classique à la tomate", ar: "كلاسيكي بالطماطم", ru: "Классический с помидором" },
  Aguacate: { fr: "Avocat", ar: "أفوكادو", ru: "Авокадо" },
  "Salmón Ahumado": { fr: "Saumon fumé", ar: "سلمون مدخّن", ru: "Копчёный лосось" },
  "Atún": { fr: "Thon", ar: "تونة", ru: "Тунец" },
  "Mermelada y mantequilla": { fr: "Confiture et beurre", ar: "مربّى وزبدة", ru: "Джем и сливочное масло" },
  Pavo: { fr: "Dinde", ar: "ديك رومي", ru: "Индейка" },
  "Croissant de mantequilla": { fr: "Croissant au beurre", ar: "كرواسون بالزبدة", ru: "Круассан на сливочном масле" },
  Napolitan: { fr: "Pain au chocolat", ar: "نابوليتانا بالشوكولاتة", ru: "Наполитана с шоколадом" },
  Caracola: { fr: "Pain aux raisins", ar: "حلزونية بالزبيب", ru: "Улитка с изюмом" },
  Trenza: { fr: "Tresse feuilletée", ar: "ضفيرة مورّقة", ru: "Слоёная косичка" },
  Muffin: { fr: "Muffin", ar: "مافن", ru: "Маффин" },
  'Tartas "raciones"': { fr: "Gâteaux (à la part)", ar: "كيك (بالقطعة)", ru: "Торты (порция)" },
  "Tarta de queso": { fr: "Cheesecake", ar: "تشيز كيك", ru: "Чизкейк" },
  Brownie: { fr: "Brownie", ar: "براوني", ru: "Брауни" },
  Cookies: { fr: "Cookies", ar: "كوكيز", ru: "Печенье" },
  Bizcocho: { fr: "Gâteau moelleux", ar: "كيك إسفنجي", ru: "Бисквит" },
  Solo: { fr: "Expresso", ar: "إسبريسو", ru: "Эспрессо" },
  "Solo Doble": { fr: "Double expresso", ar: "إسبريسو مزدوج", ru: "Двойной эспрессо" },
  Americano: { fr: "Americano", ar: "أمريكانو", ru: "Американо" },
  "Café con Leche": { fr: "Café au lait", ar: "قهوة بالحليب", ru: "Кофе с молоком" },
  Bonbon: { fr: "Café au lait concentré", ar: "قهوة بالحليب المكثّف", ru: "Кофе со сгущёнкой" },
  Cappuccino: { fr: "Cappuccino", ar: "كابتشينو", ru: "Капучино" },
  Affogato: { fr: "Affogato", ar: "أفوغاتو", ru: "Аффогато" },
  "Café Vienés con Nata": { fr: "Café viennois à la chantilly", ar: "قهوة فيينا بالكريمة", ru: "Кофе по-венски со сливками" },
  "Café Macchiato": { fr: "Café macchiato", ar: "كافيه ماكياتو", ru: "Макиато" },
  "Flat White": { fr: "Flat white", ar: "فلات وايت", ru: "Флэт уайт" },
  Matcha: { fr: "Matcha", ar: "ماتشا", ru: "Матча" },
  "Matcha Latte": { fr: "Matcha latte", ar: "ماتشا لاتيه", ru: "Матча латте" },
  "Té Infusión": { fr: "Thé / Infusion", ar: "شاي / منقوع أعشاب", ru: "Чай / травяной настой" },
  "Cola Cao": { fr: "Chocolat chaud (Cola Cao)", ar: "شوكولاتة ساخنة (كولا كاو)", ru: "Какао (Cola Cao)" },
  "Ice Latte": { fr: "Latte glacé", ar: "لاتيه مثلّج", ru: "Айс латте" },
  "Caramel Iced Latte": { fr: "Latte glacé caramel", ar: "لاتيه مثلّج بالكراميل", ru: "Айс латте с карамелью" },
  "Vanilla Iced Latte": { fr: "Latte glacé vanille", ar: "لاتيه مثلّج بالفانيليا", ru: "Айс латте с ванилью" },
  "Iced Matcha Latte": { fr: "Matcha latte glacé", ar: "ماتشا لاتيه مثلّج", ru: "Айс матча латте" },
  "Coconut Matcha Latte": { fr: "Matcha latte coco", ar: "ماتشا لاتيه بجوز الهند", ru: "Кокосовый матча латте" },
  "Chai Latte": { fr: "Chai latte", ar: "تشاي لاتيه", ru: "Чай латте" },
  "Huevos benedictinos": { fr: "Œufs Bénédicte", ar: "بيض بنديكت", ru: "Яйца Бенедикт" },
  "Huevos revueltos": { fr: "Œufs brouillés", ar: "بيض مخفوق", ru: "Яичница-болтунья" },
  Shakshuka: { fr: "Chakchouka", ar: "شكشوكة", ru: "Шакшука" },
  "Tortilla clásica de patata": { fr: "Omelette espagnole aux pommes de terre", ar: "تورتيا البطاطس الإسبانية", ru: "Испанская тортилья с картофелем" },
  Bagels: { fr: "Bagels", ar: "بيغل", ru: "Бейглы" },
  Bocaditos: { fr: "Mini-sandwichs", ar: "سندويشات صغيرة", ru: "Мини-сэндвичи" },
  Quiche: { fr: "Quiche", ar: "كيش", ru: "Киш" },
  Pancakes: { fr: "Pancakes", ar: "بان كيك", ru: "Панкейки" },
  "French Toast": { fr: "Pain perdu", ar: "توست فرنسي", ru: "Французский тост" },
  Gofres: { fr: "Gaufres", ar: "وافل", ru: "Вафли" },
  "Yogur con granola casera y frutas": { fr: "Yaourt, granola maison et fruits", ar: "لبن مع غرانولا منزلية وفواكه", ru: "Йогурт с домашней гранолой и фруктами" },
  Pistacho: { fr: "Pistache", ar: "فستق", ru: "Фисташка" },
  Vainilla: { fr: "Vanille", ar: "فانيليا", ru: "Ваниль" },
  Chocolate: { fr: "Chocolat", ar: "شوكولاتة", ru: "Шоколад" },
  Oreo: { fr: "Oreo", ar: "أوريو", ru: "Oreo" },
  "Café": { fr: "Café", ar: "قهوة", ru: "Кофе" },
  Horchata: { fr: "Horchata (lait de souchet)", ar: "أورتشاتا (حليب حب العزيز)", ru: "Орчата (из земляного миндаля)" },
  Quesos: { fr: "Fromages", ar: "أجبان", ru: "Сыры" },
  Pollo: { fr: "Poulet", ar: "دجاج", ru: "Курица" },
  Peperoni: { fr: "Pepperoni", ar: "ببروني", ru: "Пепперони" },
  Bacon: { fr: "Bacon", ar: "بيكون", ru: "Бекон" },
  Huevos: { fr: "Œufs", ar: "بيض", ru: "Яйца" },
  "Champiñones": { fr: "Champignons", ar: "فطر", ru: "Шампиньоны" },
};

// Ingrédients des pizzas : ing("salsa de tomate", "mozzarella") -> { es, fr, ar, ru }.
const ING = {
  "salsa de tomate": ["sauce tomate", "صلصة الطماطم", "томатный соус"],
  "salsa blanca": ["sauce blanche", "صلصة بيضاء", "белый соус"],
  "salsa barbacoa": ["sauce barbecue", "صلصة باربكيو", "соус барбекю"],
  mozzarella: ["mozzarella", "موزاريلا", "моцарелла"],
  ajo: ["ail", "ثوم", "чеснок"],
  parmesano: ["parmesan", "بارميزان", "пармезан"],
  albahaca: ["basilic", "ريحان", "базилик"],
  aceitunas: ["olives", "زيتون", "оливки"],
  "aceite de oliva": ["huile d'olive", "زيت الزيتون", "оливковое масло"],
  "orégano": ["origan", "أوريغانو", "орегано"],
  "jamón": ["jambon", "جامبون", "ветчина"],
  peperoni: ["pepperoni", "ببروني", "пепперони"],
  "champiñones": ["champignons", "فطر", "шампиньоны"],
  "calabacines salteados": ["courgettes sautées", "كوسة مشوّحة", "обжаренные кабачки"],
  cebolla: ["oignon", "بصل", "лук"],
  "tomate cherry": ["tomates cerises", "طماطم كرزية", "томаты черри"],
  "atún": ["thon", "تونة", "тунец"],
  "carne picada": ["viande hachée", "لحم مفروم", "мясной фарш"],
  anchoas: ["anchois", "أنشوجة", "анчоусы"],
  alcaparras: ["câpres", "كبّار", "каперсы"],
  pollo: ["poulet", "دجاج", "курица"],
  "queso azul": ["fromage bleu", "جبن أزرق", "голубой сыр"],
  comber: ["comber", "comber", "comber"], // mot de la carte à confirmer avec le client
  bacon: ["bacon", "بيكون", "бекон"],
  salchichas: ["saucisses", "نقانق", "сосиски"],
  pimientos: ["poivrons", "فلفل حلو", "перец"],
  huevos: ["œufs", "بيض", "яйца"],
  "burrata de búfala": ["burrata di bufala", "بوراتا من حليب الجاموس", "буррата из молока буйволицы"],
  "aceite de trufa": ["huile de truffe", "زيت الكمأة", "трюфельное масло"],
  "rúcula": ["roquette", "جرجير", "руккола"],
  gambas: ["crevettes", "جمبري", "креветки"],
  calamares: ["calamars", "حبّار", "кальмары"],
};
const ing = (...xs) => ({
  es: xs.join(", "),
  fr: xs.map((x) => ING[x][0]).join(", "),
  ar: xs.map((x) => ING[x][1]).join("، "),
  ru: xs.map((x) => ING[x][2]).join(", "),
});
const PZ = `${process.env.PUBLIC_URL || ""}/images/pizzas`;

export const trName = (n, lang) => (NAMES[n] && NAMES[n][lang]) || n;

export const MENU = [
  {
    id: "tostadas",
    label: { es: "Tostadas", fr: "Tartines", ar: "توست", ru: "Тосты" },
    items: [
      { n: "Aceite de oliva", p: "1.70" },
      {
        n: "Clásica de Tomate",
        p: "2.10",
        d: {
          es: "Tomate, aceite de oliva virgen extra y sal",
          fr: "Tomate, huile d'olive vierge extra et sel",
          ar: "طماطم، زيت زيتون بكر ممتاز وملح",
          ru: "Помидор, оливковое масло extra virgin и соль",
        },
      },
      { n: "Aguacate", p: "4.90", d: { es: "Tomate, aguacate", fr: "Tomate, avocat", ar: "طماطم وأفوكادو", ru: "Помидор, авокадо" } },
      {
        n: "Salmón Ahumado",
        p: "5.90",
        d: {
          es: "Queso crema, salmón, alcaparras",
          fr: "Fromage frais, saumon, câpres",
          ar: "جبن كريمي، سلمون، كبّار",
          ru: "Сливочный сыр, лосось, каперсы",
        },
      },
      {
        n: "Atún",
        p: "4.90",
        d: { es: "Tomate, atún y aceite", fr: "Tomate, thon et huile d'olive", ar: "طماطم، تونة وزيت", ru: "Помидор, тунец и масло" },
      },
      { n: "Mermelada y mantequilla", p: "2.20" },
      {
        n: "Pavo",
        p: "4.20",
        d: { es: "Tomate, pavo y aceite", fr: "Tomate, dinde et huile d'olive", ar: "طماطم، ديك رومي وزيت", ru: "Помидор, индейка и масло" },
      },
    ],
  },
  {
    id: "bolleria",
    label: { es: "Bollería", fr: "Viennoiseries", ar: "معجنات", ru: "Выпечка" },
    items: [
      { n: "Croissant de mantequilla", p: "2.30" },
      { n: "Napolitan", p: "2.60" },
      { n: "Caracola", p: "2.90" },
      { n: "Trenza", p: "2.90" },
      { n: "Muffin", p: "2.90" },
    ],
  },
  {
    id: "pasteleria",
    label: { es: "Pastelería", fr: "Pâtisserie", ar: "حلويات", ru: "Кондитерская" },
    items: [
      { n: 'Tartas "raciones"', p: "5.50" },
      { n: "Tarta de queso", p: "5.50" },
      { n: "Brownie", p: "4.00" },
      { n: "Cookies", p: "3.70" },
      { n: "Bizcocho", p: "3.80" },
    ],
  },
  {
    id: "cafes",
    label: { es: "Cafés", fr: "Cafés", ar: "قهوة", ru: "Кофе" },
    items: [
      { n: "Solo", p: "1.60" },
      { n: "Solo Doble", p: "1.90" },
      { n: "Americano", p: "2.00" },
      { n: "Café con Leche", p: "2.20" },
      { n: "Bonbon", p: "2.20" },
      { n: "Cappuccino", p: "3.50" },
      { n: "Affogato", p: "5.00" },
      { n: "Café Vienés con Nata", p: "3.70" },
      { n: "Café Macchiato", p: "2.80" },
      { n: "Flat White", p: "3.00" },
      { n: "Matcha", p: "3.90" },
      { n: "Matcha Latte", p: "4.20" },
      { n: "Té Infusión", p: "2.00" },
      { n: "Cola Cao", p: "2.60" },
    ],
  },
  {
    id: "especiales",
    label: { es: "Cafés Especiales", fr: "Cafés spéciaux", ar: "قهوة مميزة", ru: "Особые кофе" },
    items: [
      { n: "Ice Latte", p: "3.50" },
      { n: "Caramel Iced Latte", p: "4.00" },
      { n: "Vanilla Iced Latte", p: "4.00" },
      { n: "Iced Matcha Latte", p: "4.50" },
      { n: "Coconut Matcha Latte", p: "5.50" },
      { n: "Chai Latte", p: "5.50" },
    ],
  },
  {
    id: "brunch",
    label: { es: "Desayuno & Brunch", fr: "Petit-déjeuner & Brunch", ar: "فطور وبرنش", ru: "Завтрак и бранч" },
    groups: [
      {
        key: "huevo",
        title: { es: "Platos con huevo", fr: "Plats aux œufs", ar: "أطباق البيض", ru: "Блюда с яйцом" },
        items: [
          {
            n: "Huevos benedictinos",
            p: "10.20",
            d: { es: "Con salmón o pavo", fr: "Au saumon ou à la dinde", ar: "مع سلمون أو ديك رومي", ru: "С лососем или индейкой" },
          },
          {
            n: "Huevos revueltos",
            p: "7.00",
            d: { es: "Con toppings 7.90", fr: "Avec garnitures 7,90", ar: "مع إضافات 7.90", ru: "С топпингами 7,90" },
          },
          {
            n: "Shakshuka",
            p: "9.50",
            d: {
              es: "Huevos en tomate especiado",
              fr: "Œufs dans une sauce tomate épicée",
              ar: "بيض في صلصة طماطم متبّلة",
              ru: "Яйца в пряном томатном соусе",
            },
          },
          { n: "Tortilla clásica de patata", p: "4.70" },
        ],
      },
      {
        key: "saladas",
        title: { es: "Opciones saladas", fr: "Options salées", ar: "خيارات مالحة", ru: "Солёные варианты" },
        items: [
          {
            n: "Bagels",
            p: "5.30",
            d: { es: "Salmón, pollo o veggie", fr: "Saumon, poulet ou végé", ar: "سلمون، دجاج أو نباتي", ru: "Лосось, курица или вегетарианский" },
          },
          { n: "Bocaditos", p: "6.20", d: { es: "Pollo o vegano", fr: "Poulet ou vegan", ar: "دجاج أو نباتي صرف", ru: "Курица или веган" } },
          { n: "Quiche", p: "4.50", d: { es: "Espinaca o queso", fr: "Épinards ou fromage", ar: "سبانخ أو جبن", ru: "Шпинат или сыр" } },
        ],
      },
      {
        key: "dulce",
        title: { es: "Brunch dulce", fr: "Brunch sucré", ar: "برنش حلو", ru: "Сладкий бранч" },
        items: [
          { n: "Pancakes", p: "5.00" },
          {
            n: "French Toast",
            p: "7.00",
            d: { es: "Tostadas francesas con canela", fr: "Pain perdu à la cannelle", ar: "توست فرنسي بالقرفة", ru: "Французский тост с корицей" },
          },
          { n: "Gofres", p: "4.50", d: { es: "Con toppings", fr: "Avec garnitures", ar: "مع إضافات", ru: "С топпингами" } },
          { n: "Yogur con granola casera y frutas", p: "7.50" },
        ],
      },
    ],
  },
  {
    id: "pizzas",
    label: { es: "Pizzas", fr: "Pizzas", ar: "بيتزا", ru: "Пицца" },
    photos: [
      { src: `${PZ}/pizza-atun.webp`, alt: "Pizza de atún" },
      { src: `${PZ}/pizza-margarita.webp`, alt: "Pizza con aceitunas y albahaca" },
      { src: `${PZ}/pizza-vegetariana.webp`, alt: "Pizza vegetariana" },
      { src: `${PZ}/pizza-pollo.webp`, alt: "Pizza de pollo y queso azul" },
      { src: `${PZ}/pizza-carne-pollo.webp`, alt: "Pizza de carne picada y pollo" },
    ],
    groups: [
      {
        key: "clasicas",
        title: { es: "Pizzas clásicas", fr: "Pizzas classiques", ar: "بيتزا كلاسيكية", ru: "Классические пиццы" },
        items: [
          { n: "Pizza Marinera", p: "8.00", d: ing("salsa de tomate", "mozzarella", "ajo", "parmesano", "albahaca", "aceitunas") },
          { n: "Pizza Margarita", p: "9.50", d: ing("salsa de tomate", "mozzarella", "albahaca", "aceite de oliva", "orégano") },
          { n: "Pizza Bella", p: "11.00", d: ing("salsa de tomate", "mozzarella", "jamón", "orégano") },
          { n: "Pizza Divalo", p: "11.00", d: ing("salsa de tomate", "mozzarella", "peperoni", "orégano") },
          {
            n: "Pizza Vegetariana",
            p: "11.00",
            d: ing("salsa de tomate", "mozzarella", "champiñones", "calabacines salteados", "cebolla", "tomate cherry", "aceitunas"),
          },
          { n: "Pizza Atún", p: "11.50", d: ing("salsa de tomate", "mozzarella", "atún", "cebolla", "aceitunas", "orégano") },
          { n: "Pizza Barbacoa", p: "12.00", d: ing("salsa de tomate", "mozzarella", "carne picada", "cebolla", "salsa barbacoa", "orégano") },
          { n: "Pizza Napolitana", p: "12.00", d: ing("salsa de tomate", "anchoas", "alcaparras", "aceitunas", "orégano") },
          { n: "Pizza Carne Picada", p: "12.00", d: ing("salsa de tomate", "mozzarella", "carne picada", "cebolla", "orégano") },
          { n: "Pizza de Pollo", p: "12.00", d: ing("salsa de tomate", "mozzarella", "pollo", "orégano") },
        ],
      },
      {
        key: "premium",
        title: { es: "Pizzas premium", fr: "Pizzas premium", ar: "بيتزا مميزة", ru: "Премиум пиццы" },
        items: [
          { n: "Pizza Cuatro Fromaggi", p: "13.00", d: ing("salsa blanca", "mozzarella", "queso azul", "parmesano", "comber", "orégano") },
          { n: "Pizza Peperoni", p: "13.00", d: ing("salsa de tomate", "mozzarella", "peperoni", "bacon", "orégano") },
          { n: "Pizza Orientale", p: "13.50", d: ing("salsa de tomate", "mozzarella", "salchichas", "pimientos", "huevos", "orégano") },
          {
            n: "Pizza Burrata",
            p: "15.50",
            d: ing("salsa de tomate", "mozzarella", "burrata de búfala", "aceite de trufa", "rúcula", "orégano"),
          },
          { n: "Pizza Costa del Mar", p: "15.50", d: ing("salsa de tomate", "mozzarella", "gambas", "calamares", "orégano") },
        ],
      },
      {
        key: "suplementos",
        title: { es: "Suplementos", fr: "Suppléments", ar: "إضافات", ru: "Добавки" },
        items: [
          { n: "Quesos", p: "1.50" },
          { n: "Pollo", p: "2.00" },
          { n: "Peperoni", p: "2.00" },
          { n: "Bacon", p: "2.00" },
          { n: "Huevos", p: "1.00" },
          { n: "Champiñones", p: "1.00" },
        ],
      },
    ],
    foot: {
      es: "Consulta a nuestro personal si tienes alguna alergia o intolerancia alimentaria.",
      fr: "Consultez notre personnel en cas d'allergie ou d'intolérance alimentaire.",
      ar: "استشر طاقمنا إذا كانت لديك أي حساسية أو عدم تحمّل غذائي.",
      ru: "Сообщите персоналу, если у вас есть аллергия или пищевая непереносимость.",
    },
  },
  {
    id: "gofres",
    label: { es: "Gofres & Crepes", fr: "Gaufres & Crêpes", ar: "وافل وكريب", ru: "Вафли и блинчики" },
    note: {
      es: "5.00 € · +2.00 € topping extra",
      fr: "5,00 € · +2,00 € garniture supplémentaire",
      ar: "5.00 € · +2.00 € لكل إضافة",
      ru: "5,00 € · +2,00 € доп. топпинг",
    },
    steps: [
      {
        k: "1",
        t: { es: "Elige tu base", fr: "Choisissez la base", ar: "اختر الأساس", ru: "Выберите основу" },
        v: { es: "Gofre o crepe", fr: "Gaufre ou crêpe", ar: "وافل أو كريب", ru: "Вафля или блинчик" },
      },
      {
        k: "2",
        t: { es: "Elige tu contenido", fr: "Choisissez la garniture", ar: "اختر الحشوة", ru: "Выберите наполнение" },
        v: {
          es: "Fresas · Plátano · Frambuesas · Nata · Pecanas · Oreo",
          fr: "Fraises · Banane · Framboises · Chantilly · Noix de pécan · Oreo",
          ar: "فراولة · موز · توت العليق · كريمة · جوز البقان · أوريو",
          ru: "Клубника · Банан · Малина · Сливки · Пекан · Oreo",
        },
      },
      {
        k: "3",
        t: { es: "Elige tu topping", fr: "Choisissez le topping", ar: "اختر الصلصة", ru: "Выберите топпинг" },
        v: {
          es: "Nutella · Chocolate · Caramelo salado · Sirope de fresa · Crema de cacahuete · Lacasitos",
          fr: "Nutella · Chocolat · Caramel beurre salé · Sirop de fraise · Beurre de cacahuète · Smarties",
          ar: "نوتيلا · شوكولاتة · كراميل مملّح · شراب الفراولة · زبدة الفول السوداني · حبات ملوّنة",
          ru: "Nutella · Шоколад · Солёная карамель · Клубничный сироп · Арахисовая паста · Драже",
        },
      },
    ],
  },
  {
    id: "smoothies",
    label: { es: "Smoothies & Sorbetes", fr: "Smoothies & Sorbets", ar: "سموذي وسوربيه", ru: "Смузи и сорбеты" },
    groups: [
      {
        key: "sorbetes",
        title: { es: "Sorbetes · 4.00 €", fr: "Sorbets · 4,00 €", ar: "سوربيه · 4.00 €", ru: "Сорбеты · 4,00 €" },
        flat: {
          es: ["Mango", "Fresa", "Limón", "Maracuyá", "Coco", "Frutos rojos", "Piña", "Sandía"],
          fr: ["Mangue", "Fraise", "Citron", "Fruit de la passion", "Coco", "Fruits rouges", "Ananas", "Pastèque"],
          ar: ["مانجو", "فراولة", "ليمون", "باشن فروت", "جوز الهند", "توت أحمر", "أناناس", "بطيخ"],
          ru: ["Манго", "Клубника", "Лимон", "Маракуйя", "Кокос", "Красные ягоды", "Ананас", "Арбуз"],
        },
      },
      {
        key: "smoothies",
        title: { es: "Smoothies · 5.80 €", fr: "Smoothies · 5,80 €", ar: "سموذي · 5.80 €", ru: "Смузи · 5,80 €" },
        flat: {
          es: ["Fresa", "Mango", "Banana", "Piña", "Frutos rojos", "Kiwi", "Verde (espinaca + manzana)", "Tropical (mango + piña + naranja)"],
          fr: ["Fraise", "Mangue", "Banane", "Ananas", "Fruits rouges", "Kiwi", "Vert (épinard + pomme)", "Tropical (mangue + ananas + orange)"],
          ar: ["فراولة", "مانجو", "موز", "أناناس", "توت أحمر", "كيوي", "أخضر (سبانخ + تفاح)", "استوائي (مانجو + أناناس + برتقال)"],
          ru: ["Клубника", "Манго", "Банан", "Ананас", "Красные ягоды", "Киви", "Зелёный (шпинат + яблоко)", "Тропический (манго + ананас + апельсин)"],
        },
      },
      {
        key: "diy",
        title: { es: "Arma el tuyo", fr: "Composez le vôtre", ar: "اصنع سموذيك", ru: "Соберите свой" },
        flat: {
          es: ["Base: agua, leche o yogurt", "Elige 2-3 frutas", "Extras: nutella, miel, crema, mantequilla de maní"],
          fr: ["Base : eau, lait ou yaourt", "Choisissez 2-3 fruits", "Extras : nutella, miel, crème, beurre de cacahuète"],
          ar: ["الأساس: ماء أو حليب أو لبن", "اختر 2-3 فواكه", "إضافات: نوتيلا، عسل، كريمة، زبدة الفول السوداني"],
          ru: ["Основа: вода, молоко или йогурт", "Выберите 2-3 фрукта", "Экстра: nutella, мёд, сливки, арахисовая паста"],
        },
      },
    ],
  },
  {
    id: "batidos",
    label: { es: "Batidos", fr: "Milkshakes", ar: "ميلك شيك", ru: "Молочные коктейли" },
    note: "5.80 €",
    items: [
      { n: "Pistacho", p: "5.80" },
      { n: "Vainilla", p: "5.80" },
      { n: "Chocolate", p: "5.80" },
      { n: "Oreo", p: "5.80" },
      { n: "Café", p: "5.80" },
      { n: "Horchata", p: "5.80" },
    ],
  },
];
